import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "font-comfortaa-b" }, "lazy beck")
], -1)
const _hoisted_2 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_sider, {
      class: "lb-shadow",
      breakpoint: "xs",
      onBreakpoint: _ctx.shadowOnBreakpoint,
      collapsed: _ctx.shadowCollapsed,
      collapsedWidth: _ctx.shadowCollapsedWidth,
      width: _ctx.shadowWidth,
      trigger: null
    }, null, 8, ["onBreakpoint", "collapsed", "collapsedWidth", "width"]),
    _createVNode(_component_a_layout_sider, {
      class: _normalizeClass(["lb-sider", _ctx.menuCollapsed ? 'lb-sider-collapsed' : '']),
      breakpoint: "lg",
      collapsed: _ctx.menuCollapsed,
      collapsedWidth: _ctx.menuCollapsedWidth,
      onCollapse: _ctx.menuOnCollapse,
      collapsible: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_menu, {
            mode: "inline",
            theme: "dark",
            inlineCollapsed: _ctx.collapsed,
            openKeys: _ctx.openKeys,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (m1) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  ((!m1.children || m1.children.length === 0) && m1.title)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: m1.key
                      }, {
                        icon: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["iconfont", `icon-${m1.icon}`])
                            }, null, 2)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: { name: m1.name, params: m1.params }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(m1.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (m1.children && m1.children.length !== 0)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: m1.key
                      }, {
                        icon: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["iconfont", `icon-${m1.icon}`])
                            }, null, 2)
                          ])
                        ]),
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(m1.title), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m1.children, (m2) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              ((!m2.children || m2.children.length === 0) && m2.title)
                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: m2.key
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_router_link, {
                                        to: { name: m2.name, params: m2.params }
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(m2.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (m2.children && m2.children.length !== 0)
                                ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: m2.key
                                  }, {
                                    title: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(m2.title), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m2.children, (m3) => {
                                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                                          key: m3.key
                                        }, {
                                          default: _withCtx(() => [
                                            (m3.title)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  to: { name: m3.name, params: m3.params }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(m3.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          }, 8, ["inlineCollapsed", "openKeys", "selectedKeys"])
        ])
      ]),
      _: 1
    }, 8, ["class", "collapsed", "collapsedWidth", "onCollapse"])
  ], 64))
}